import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { track } from '@/utils/amplitude/analytics/core';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { TrackingEvents, TrackingPayload } from '../core.types';

type TrackSearchSuggestionClickedPayload = TrackingPayload & {
    suggestedClickPosition: number;
    suggestedQueryClicked: string;
    url: string;
};

export const trackSearchSuggestionClickedAnalytics = (payload: TrackSearchSuggestionClickedPayload) => {
    track(TrackingEvents.SearchPage.SearchSuggestionClicked, payload);
};

export const useTrackSearchSuggestionClicked = () => {
    const { pathname } = useLocation();

    return useCallback(
        ({
            suggestedClickPosition,
            suggestedQueryClicked,
            url: destinationUrl,
        }: Omit<TrackSearchSuggestionClickedPayload, 'pageName'>) => {
            return trackSearchSuggestionClickedAnalytics({
                pageName: getAmplitudePageNameFromPath(pathname),
                suggestedClickPosition,
                suggestedQueryClicked,
                url: destinationUrl,
            });
        },
        [pathname]
    );
};
